module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bea Boccalandro\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Bea Boccalandro")]), _vm._v(" advises business leaders on igniting social purpose in the workplace and helps workers end their workweek knowing they made a difference. As founder and president of VeraWorks, a business purpose advisory firm, Bea has two decades of experience making customer interactions more human, products more inclusive, meetings more meaningful, operations more environmentally sustainable, marketing more charitable, and otherwise igniting purpose in the workplace. Her clients include Bank of America, Caesars Entertainment, Disney, CVS Health, Eventbrite, FedEx, HP, John Hancock, IBM, Levi's, PwC, TOMS Shoes, Toyota and Western Digital. Her work has been featured on "), _c('I', [_vm._v("FOX TV, Business Digest, Forbes")]), _vm._v(" and "), _c('I', [_vm._v("Harvard Business Review")]), _vm._v("."), _c('br'), _c('P', [_vm._v("Bea also has 15 years of experience teaching business purpose and corporate social responsibility (CSR) at Georgetown University, Boston College and the University of Nevada, Las Vegas. Furthermore, her speeches across more than 50 countries have inspired tens of thousands of people to make their work more meaningful. She lives with her husband in San Clemente, California, where she frequently embarrasses herself as a beginner surfer. Learn more at www.BeaBoccalandro.com.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BIP3Cs/tc-custom/9781642797534.jpg?1729034189997",
      "alt": "This image is the cover for the book Do Good At Work"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Do Good At Work\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A delightful do-it-yourself guide to igniting meaning in any job.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Morgan James Publishing\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0